import { userContext } from '../userManager';
import { getStartAndEndDateByTag } from '../../utils/dates';

export const apiModelPortfoliosGet = (userId, { riskProfileId } = {}) =>
  userContext.apiCall({ url: `/users/${userId}/model-portfolios`, qs: { riskProfileId } });

export const apiModelPortfoliosPost = (userId, { name, riskProfileId, category, serviceTypeId }) =>
  userContext.apiCall({
    url: `/users/${userId}/model-portfolios`,
    method: 'POST',
    body: {
      name,
      riskProfileId,
      category,
      serviceTypeId
    },
  });

export const apiModelPortfoliosDelete = (modelPortfolioId) =>
  userContext.apiCall({
    url: `/model-portfolios/${modelPortfolioId}`,
    method: 'DELETE',
    noResBody: true,
  });

export const apiModelPortfoliosHoldingsGet = (modelPortfolioId) =>
  userContext.apiCall({ url: `/model-portfolios/${modelPortfolioId}/holdings` });

export const apiModelPortfoliosDetailsGet = (modelPortfolioId) =>
  userContext.apiCall({ url: `/model-portfolios/${modelPortfolioId}` });

export const apiModelPortfolioPerformancesGet = (
  modelPortfolioId,
  { benchmarkId, yearsTag, compareIds }
) => {
  let startDate;
  if (yearsTag) {
    startDate = getStartAndEndDateByTag(yearsTag).startDate;
  }

  const compareMandateIds = compareIds ?? '';
  return userContext.apiCall({
    url: `/model-portfolios/${modelPortfolioId}/performances`,
    qs: {
      compareInstrumentIds: compareMandateIds ?? '',
      benchmarkId,
      startDate,
    },
  });
};

export const apiModelPortfoliosKpisGet = (modelPortfolioId) =>
  userContext.apiCall({ url: `/model-portfolios/${modelPortfolioId}/kpis` });

export const apiModelPortfoliosHoldingsPatch = (modelPortfolioId, { holdings }) =>
  userContext.apiCall({
    url: `/model-portfolios/${modelPortfolioId}/holdings`,
    method: 'PATCH',
    body: { holdings },
  });

export const apiModelPortfoliosMaxDrawdownGet = ({
  modelPortfolioId,
  startDate,
  endDate,
  benchmarkId,
  samplingInterval,
}) =>
  userContext.apiCall({
    url: `/model-portfolios/${modelPortfolioId}/max-drawdown`,
    qs: { startDate, endDate, benchmarkIndexId: benchmarkId, samplingInterval },
  });
